var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"search"}},[(_vm.isBasic)?_c('search-basic'):_vm._e(),(_vm.isFednet)?_c('search-fednet'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }